export enum ESquad {
  ZONA_BARCELONA = "Zona Barcelona",
  ZONA_MADRID = "Zona Madrid",
  ZONA_BILBAO_ZARAGOZA_VALENCIA = "Zona Bilbao / Valencia / Zaragoza",
  RESTO_ZONAS = "Resto de zonas",
}

export const SQUADS_ABLE_TO_RUN_BOT = [
  ESquad.ZONA_BILBAO_ZARAGOZA_VALENCIA,
  ESquad.RESTO_ZONAS,
  ESquad.ZONA_BARCELONA,
  ESquad.ZONA_MADRID,
];
